import { ExtensionGroupOption } from 'src/app/pages/extension-register/models/extension-group-option.interface';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';

export interface IncomingExtensionHuntGroupData {
   huntGroupMembers: HuntGroupMember[];
   huntGroupExtensionGroups: HuntGroupExtensionGroup[];
}

export interface IncomingExtensionPagingGroupData {
   pagingGroupMembers: PagingGroupMember[];
   pagingGroupExtensionGroups: PagingGroupExtensionGroup[];
}

export interface IncomingExtensionQueueData {
   queueMembers: ExtensionQueueMember[];
   queueExtensionGroupMembers: ExtensionQueueExtensionGroup[];
}

export interface IncomingExtensionSuperviseeData {
   extensionSupervisees: ExtensionSupervisee[];
   extensionGroupSupervisees: ExtensionGroupSupervisee[];
}

export interface ExtensionSupervisee {
   extensionSuperviseeId: number;
   extensionId: number;
   extension: ExtensionOption;
}

export interface ExtensionGroupSupervisee {
   extensionGroupSuperviseeId: number;
   extensionGroupId: number;
   extensionGroup: ExtensionGroupOption;
}

export interface ExtensionQueueMember {
   extensionQueueMemberId: number;
   extensionId: number;
   extension: ExtensionOption;
   isArchived: boolean;
}

export interface ExtensionQueueExtensionGroup {
   extensionQueueExtensionGroupId: number;
   extensionGroupId: number;
   extensionGroup: ExtensionGroupOption;
}

export interface HuntGroupMember {
   huntGroupMemberId: number;
   extensionId: number;
   extension: ExtensionOption;
}

export interface PagingGroupMember {
   pagingGroupMemberId: number;
   extensionId: number;
   extension: ExtensionOption;
}

export interface HuntGroupExtensionGroup {
   huntGroupExtensionGroupId: number;
   extensionGroupId: number;
   extensionGroup: ExtensionGroupOption;
}

export interface PagingGroupExtensionGroup {
   pagingGroupExtensionGroupId: number;
   extensionGroupId: number;
   extensionGroup: ExtensionGroupOption;
}

export interface ChipInputOption {
   id: number;
   type: ChipInputType;
   huntGroupExtensionGroupId: number | null;
   huntGroupMemberId: number | null;
   pagingGroupExtensionGroupId: number | null;
   pagingGroupMemberId: number | null;
   queueExtensionGroupId: number | null;
   queueMemberId: number | null;
   extensionGroupId: number | null;
   extensionId: number | null;
   extensionSuperviseeId: number | null;
   extensionGroupSuperviseeId: number | null;
   value: ExtensionOption | ExtensionGroupOption;
   isDeleted: boolean;
}

export enum ChipInputType {
   Extension = 'Extension',
   ExtensionGroup = 'ExtensionGroup',
}

export interface ExtensionOptionWithName extends ExtensionOption {
   name: string;
}

export interface ExtensionGroupOptionWithName extends ExtensionGroupOption {
   name: string;
}

export type ChipInputValue = ExtensionOptionWithName | ExtensionGroupOptionWithName;

export interface ChipInputOptionWithValue extends ChipInputOption {
   value: ChipInputValue;
}
